import * as React from "react";
import {Link} from "react-router-dom";
import SearchBarContainer from "../../search/containers/SearchBarContainer";
import * as classNames from "classnames";
import {currentUserIsLoggedIn} from "../../_helpers/utils";
import {ChildrenType} from "../../_definitions/styleteq";
import {Api} from "../../_helpers/api";

interface  Props {
    children: ChildrenType;
}

const ContentComponent = (props: Props) => {
    const {children} = props;
    const classes = classNames("dashboard-main", {"off-canvas-content": currentUserIsLoggedIn()});
    return (
        <div className={classes} data-off-canvas-content>
            <div className="title-bar hidden" data-responsive-toggle="widemenu" data-hide-for="medium">
                <div className="title-bar-left">
                    <button className="menu-icon" type="button" data-open="offCanvasLeft"/>
                </div>
                <div className="title-bar-right">
                    <a href="register-stylist.html" className="button primary small">
                        <i className="fa fa-certificate fa-fw"/>
                        Become A Stylist</a>
                    <Link to="/">
                        <i className="fa fa-sign-out fa-fw"/> Sign Out
                    </Link>
                </div>
            </div>
            <SearchBarContainer/>
            {children}            
        </div>
    );
};
export default ContentComponent;


// WEBPACK FOOTER //
// ./app/client/dashboard/components/ContentComponent.tsx